<script>
    // Import animated counter component
    import Vue3Autocounter from 'vue3-autocounter';

    export default {
        components: {
            Vue3Autocounter
        },
        props: {
            data: Object,
        },
        data() {
            return {
                facetAliasHeadsum: 'hoofdsom_totaal',
                facetAliasReceived: 'bedrag_door_u_ontvangen_inc_btw_voordeel',
                facetAliasPaid: 'bedrag_door_u_betaald_inc_btw',
            };
        },
        computed: {
            sumsSet() {
                return this.data && this.data.sums;
            },
            headsum() {
                if (!this.sumsSet) return 0;
                return this.data.sums[this.facetAliasHeadsum] || 0;
            },
            sumReceived() {
                if (!this.sumsSet) return 0;
                return this.data.sums[this.facetAliasReceived] || 0;
            },
            sumPaid() {
                if (!this.sumsSet) return 0;
                return this.data.sums[this.facetAliasPaid] || 0;
            },
        },
    };
</script>

<template>
    <div class="dashboard-widget is-flex is-flex-direction-column is-justify-content-space-evenly">
        <div class="is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardWidgetSumsHeadsum') }}</span>
            <vue3-autocounter :endAmount="headsum" prefix="€ " decimals="2" separator="." decimalSeparator="," duration="0.5" />
        </div>
        <div class="is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardWidgetSumsReceived') }}</span>
            <vue3-autocounter :endAmount="sumReceived" prefix="€ " decimals="2" separator="." decimalSeparator="," duration="0.5" />
        </div>
        <div class="is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardWidgetSumsPaid') }}</span>
            <vue3-autocounter :endAmount="sumPaid" prefix="€ " decimals="2" separator="." decimalSeparator="," duration="0.5" />
        </div>
    </div>
</template>
